import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../constants/ApiConntection";
import LoadingSpinner from "../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

export default function ConceptForm() {
  const [phone, setPhone] = useState("");
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navi = useNavigate();
  const [capVal, setCapVal] = useState(null);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    contactPreference: "",
    projectType: "website",
    concept: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });

    if (e.target.name === "phone") {
      setPhone(e.target.value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const enquiry = {
      name: form.name,
      email: form.email,
      phone: form.phone,
      contactPreference: phone.trim() === "" ? "email" : form.contactPreference,
      projectType: form.projectType,
      concept: form.concept
    };

    const response = await axios.post(`${ApiConnectionString}/api/Enquiry`, enquiry);
    setIsLoading(false);

    if (response.status === 200) {
      setComplete(true);
      setCapVal(null);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (complete) {
    return (
      <div className="custom-card-light rounded p-4 mt-4 text-center">
        <h4 className="fw-bold mb-3">Thank you</h4>
        <p className="text-muted mb-4">
          Your enquiry has been sent. I will review everything and get back to you soon.
        </p>

        <button
          className="btn brand-purple-inline"
          onClick={() => navi("/")}
        >
          Return home
        </button>
      </div>
    );
  }

  return (
    <div className="custom-card-light rounded p-4 mt-4">
      <h4 className="fw-bold mb-3">Tell me about your concept</h4>

      <p className="text-muted">
        Please describe what you would like built and include any details that will help
        me understand your idea. I will review everything and get in touch.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label fw-semibold">Your name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            placeholder="John Smith"
            value={form.name}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Email address</label>
          <input
            type="email"
            className="form-control"
            name="email"
            placeholder="you@example.com"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Phone number (optional)</label>
          <input
            type="text"
            className="form-control"
            name="phone"
            placeholder="01234 567890"
            value={form.phone}
            onChange={handleChange}
          />
        </div>

        {phone.trim() !== "" && (
          <div className="mb-3">
            <label className="form-label fw-semibold">Preferred method of contact</label>
            <select
              className="form-select"
              name="contactPreference"
              value={form.contactPreference}
              onChange={handleChange}
            >
              <option value="email">Email</option>
              <option value="phone">Phone</option>
            </select>
          </div>
        )}

        <div className="mb-3">
          <label className="form-label fw-semibold">Project type</label>
          <select
            className="form-select"
            name="projectType"
            value={form.projectType}
            onChange={handleChange}
          >
            <option value="website">Website</option>
            <option value="mobile">Mobile app</option>
            <option value="ai">AI integration</option>
            <option value="other">Other</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Your concept</label>
          <textarea
            className="form-control"
            rows="5"
            name="concept"
            placeholder="Describe your idea..."
            value={form.concept}
            onChange={handleChange}
          ></textarea>
        </div>

        <div className="mb-3 d-flex justify-content-center">
          <ReCAPTCHA
            sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
            onChange={(val) => setCapVal(val)}
          />
        </div>

        <div className="d-flex justify-content-end">
          {!capVal ? (
            <button
              type="submit"
              disabled={true}
              className="btn brand-purple-inline"
            >
              Send
            </button>
          ) : (
            <button
              type="submit"
              className="btn brand-purple-inline"
            >
              Send
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
